import { ICompilerContext } from "@hooks/usePreviewCompiler";
import { createContext } from "react";

const CodeCompilerContext = createContext({} as ICompilerContext);

export default CodeCompilerContext;